import api from '../..'

export const editProfiles = (userId: number, profiles: any) => {
  return api
    .post(`administration/users/${userId}/profiles`, {
      user: { id: userId, profilesThroughUserIds: profiles },
    })
    .then(({ data }) => {
      return data
    })
}
